import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../../MenuButton.jsx'

export default function MenuButtonPublishProduct(props) {
    const map = useMapContext()
    const permission = map.usePermission()
    map.useNodeChange(map.root, ['data'])

    if (! permission.has('write')) {
        return null
    }

    const handleClick = () => map.commands.pushSavePublish()

    const children = '_DES_MAP' === map.data.mapTypeCode ?
        '更新&提交' : '更新&发布制品'

    return (
        <MenuButton
            onClick={handleClick}
            {...props}
        >
            {children}
        </MenuButton>
    )
}
